import { GlobalOutlined, HomeOutlined, PhoneOutlined } from "@ant-design/icons";
import logo from "../../../../assets/images/logo-horizontal.png"
export default function DocumentLogo() {
  return (
    <>
      <div className="border border-black px-2 flex flex-row justify-between items-center text-xs">
        <div className="w-full sm:w-4/6">
          <div className="flex w-64">
            <img src={logo} alt="" />
          </div>
        </div>
        <div className="flex flex-col justify-end w-full sm:w-2/6">
          <div className="px-2 font-bold text-lg">Toyota Tanzania Ltd</div>
          <div className="px-2 flex flex-row">
            <div className="mr-2">
              <HomeOutlined />
            </div>
            <div className="flex-col">
              <div className="">Nyerere Road, Plot No. 19</div>
              <div className="">Box 9060, Dar es salaam</div>
            </div>
          </div>
          <div className="px-2 flex flex-row items-center">
            <div className="mr-2">
              <PhoneOutlined />
            </div>
            <div className=""> (+255) 22 2118990-1</div>
          </div>
          <div className="px-2 flex flex-row items-center">
            <div className="mr-2">
              <HomeOutlined />
            </div>
            <div className="">sales@toyota.co.tz</div>
          </div>
          <div className="px-2 flex flex-row items-center">
            <div className="mr-2">
              <GlobalOutlined />
            </div>
            <div className="">www.toyota.co.tz</div>
          </div>
        </div>
      </div>
    </>
  );
}
